import { render, staticRenderFns } from "./ContractMailingListPopover.vue?vue&type=template&id=f9acd2cc&scoped=true"
import script from "./ContractMailingListPopover.vue?vue&type=script&lang=ts"
export * from "./ContractMailingListPopover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9acd2cc",
  null
  
)

export default component.exports